import { RouteObject, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import Login from './pages/login/Login';
import NotFound from './pages/NotFound/NotFound';
import Dashboard from './pages/dashboard/Dashboard';
import Organizations from './pages/organizations/select/Organizations';
import Files from './pages/Files/Files';
import Personnel from './pages/Personnel/Personnel';
import Settings from './pages/settings/Settings';
import CreateOrganization from './pages/organizations/create/CreateOrganization';
import Profile from './pages/Profile/Profile';
import CalculatePage from './pages/Calculate/CalculatePage';
import HistoryPage from './pages/History/HistoryPage';
import JobRunsPage from './pages/JobRuns/JobRunsPage';
import ChartConfigPage from './pages/ChartConfig/ChartConfigPage';
import PersonnelInvite from './pages/Personnel/Invite/PersonnelInvite';
import Testpage from './pages/Test/Testpage';
import AuthAction from './pages/auth/AuthAction';
import { AdminGuard } from './pages/admin/AdminGuard';
import { AdminLayout } from './pages/admin/AdminLayout';
import { Organizations as AdminOrganizations } from './pages/admin/Organizations';
import { OrganizationDetails } from './pages/admin/OrganizationDetails';
import { Developers } from './pages/admin/Developers';

export const routes: RouteObject[] = [
  // login route
  { path: '/', element: <Home /> },
  { path: '/login', element: <Login /> },
  { path: '/auth/action', element: <AuthAction /> },
  { path: '/dashboard', element: <Navigate to="/naeras" replace /> },
  { path: '/organizations', element: <Organizations /> },
  { path: '/organizations/create', element: <CreateOrganization /> },
  { path: '/files', element: <Files /> },
  { path: '/naeras', element: <Dashboard /> },
  { path: '/naeras/hybrid', element: <CalculatePage /> },
  { path: '/history', element: <HistoryPage /> },
  { path: '/job-runs', element: <JobRunsPage /> },
  { path: '/chart-config', element: <ChartConfigPage /> },
  { path: '/personnel/invite', element: <PersonnelInvite /> },
  { path: '/personnel', element: <Personnel /> },
  { path: '/settings', element: <Settings /> },
  { path: '/profile', element: <Profile /> },
  { path: '/test', element: <Testpage /> },

  // Admin CAS routes
  {
    path: '/admin',
    element: <AdminGuard />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/admin/organizations" replace /> },
          { path: 'organizations', element: <AdminOrganizations /> },
          { path: 'organizations/:id', element: <OrganizationDetails /> },
          { path: 'developers', element: <Developers /> },
        ]
      }
    ]
  },

  // Not found route
  { path: '*', element: <NotFound /> },
];
